// extracted by mini-css-extract-plugin
export default {"newsletter":"Newsletter_newsletter__V2cIG"};